module.exports = __webpack_public_path__ + "img/5_การยืมคืน.560d6e67.png";